import React, { ReactNode } from "react"
import {
  Box, Flex, HStack, Text, useRadioGroupContext,
} from "@chakra-ui/react"
import FallbackIcon from "components/EventLink/FallbackIcon"
import RadioCard from "components/inputs/RadioCard"
import { EventEntryTarget } from "sharedTypes"
import { LinkActions, UrlText } from "./LinkParts"

type Props = {
  value: EventEntryTarget
  icon: string
  title: string
  description: ReactNode
  slug?: string | null
  url?: string
  badge?: ReactNode
  note?: string
  children?: ReactNode
}

const Destination = ({
  value, icon, title, description, slug, url, badge, note, children,
}: Props) => {
  const selected = useRadioGroupContext()?.value === value

  return (
    <RadioCard
      value={value}
      icon={icon}
      title={title}
      description={description}
      badge={(badge || note) && (
      <HStack spacing={1.5}>
        {badge}
        {note && <FallbackIcon note={note} />}
      </HStack>
      )}
    >
      {note && selected && (
      <Text mt={1} color="orange.500" fontWeight="semibold">{note}</Text>
      )}
      {children}
      {url && (
      <Flex align="center" justify="space-between" gap={3} mt={2} minW={0}>
        <UrlText url={url} slug={slug} />
        <Box my={-1}><LinkActions url={url} /></Box>
      </Flex>
      )}
    </RadioCard>
  )
}

export default Destination
